import { render } from "./category-popup.vue?vue&type=template&id=08339864&scoped=true"
import script from "./category-popup.vue?vue&type=script&lang=js"
export * from "./category-popup.vue?vue&type=script&lang=js"

import "./category-popup.vue?vue&type=style&index=0&id=08339864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08339864"]])

export default __exports__